var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const noop = () => {
    return {
        dispose: () => { },
    };
};
export var NsXFlowHook;
(function (NsXFlowHook) {
    NsXFlowHook.CONFIG_TYPE = 'XFlowHook';
})(NsXFlowHook || (NsXFlowHook = {}));
export class HookConfig {
    constructor() {
        /** CONFIG_TYPE */
        this.CONFIG_TYPE = NsXFlowHook.CONFIG_TYPE;
        this.time = Date.now();
        /** 提供一个runtime注册hook的方式 */
        this.setRegisterHook = (fn) => {
            this.hookRegisterFunc = fn;
        };
        /** 这里在canvas上提供一个runtime注册hookhub的方式 */
        this.setRegisterHookhub = (fn) => {
            this.hookhubRegisterFn = fn;
        };
        this.getConfig = () => __awaiter(this, void 0, void 0, function* () {
            const options = {
                CONFIG_TYPE: this.CONFIG_TYPE,
                hookRegisterFn: this.hookRegisterFunc || noop,
                hookhubRegisterFn: this.hookhubRegisterFn || noop,
            };
            return options;
        });
        this.dispose = () => { };
    }
}
//# sourceMappingURL=config.js.map